export default "__VITE_ASSET__CQJGR6Hc__"